<template>
  <v-dialog :value="showExportDialog" @input="v => v || HIDE_EXPORT_DIALOG()" max-width="600px" scrollable>
    <v-card>
      <!-- TITLE -->
      <v-card-title class="teal darken-1">
        <span class="headline">تصدير إكسيل</span>
      </v-card-title>

      <!-- INPUTS -->
      <v-card-text class="pt-5 pb-0">
        <v-container>
          <v-progress-linear
            v-if="formLoading"
            color="teal darken-1"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <div v-else>
            <v-select
              dense
              label="التقرير"
              outlined
              v-model="form.type"
              :items="[
                {text: 'أعداد المستخدمين و المشاهدات اليومية', value: 'visitors-views'},
                {text: 'صفحات الموقع', value: 'pages'}
              ]"
              :error-messages="errors.type"
            ></v-select>
            <v-select
              dense
              label="السنة"
              outlined
              v-model="form.year"
              :items="allowedYears"
              :error-messages="errors.year"
            ></v-select>
          </div>
        </v-container>
      </v-card-text>

      <!-- ACTIONS -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          dark
          color="teal darken-1"
          elevation="1"
          :loading="formLoading"
          @click="exportExcel(form)"
        >تصدير</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'export-excel',


  data: function () {
    return {
      form: {},
      errors: {},
      formLoading: false,
    }
  },


  computed: {
    ...mapState(
      'statistics',
      {
        showExportDialog: state => state.showExportDialog,
        filters: state => {
          return {
            year: (new Date()).getFullYear(),
            type: state.filters.type
          };
        }
      }
    ),

    allowedYears() {
      let years = [];
      let year = 2020;  // first year
      let currentYear = (new Date()).getFullYear();

      while (currentYear >= year) {
        years.push(year++);
      }

      return years;
    }
  },


  watch: {
    filters(form) { this.form = form; }
  },


  methods: {
    ...mapMutations(
      'statistics',
      [
        'HIDE_EXPORT_DIALOG'
      ]
    ),

    exportExcel(form) {
      this.formLoading = true;

      this.axios({
        url: '/admin/statistics/export-excel',
        method: 'GET',
        responseType: 'blob',
        params: form
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${form.type}-${form.year}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .finally(() => {
        this.formLoading = false;
        this.HIDE_EXPORT_DIALOG();
      });
    }
  }
}
</script>
